// extracted by mini-css-extract-plugin
export default {"BookmarkGrid":"BookmarkGrid_BookmarkGrid__i3Tj4"};